(() => {
	// The client logo row scrolls continuously. Cloning the set once means the
	// track can animate a clean -50% and land exactly where it started, so the
	// loop has no visible seam. The marquee class is only added after cloning,
	// so the row stays static if this never runs.
	document.querySelectorAll('.block-logo-grid:not(.block-logo-grid--natural):not(.block-logo-grid--wrapped)').forEach((row) => {
		const track = row.querySelector('.acf-innerblocks-container');

		if (!track || track.dataset.marqueeReady) {
			return;
		}

		const logos = Array.from(track.children);

		if (logos.length < 2) {
			return;
		}

		logos.forEach((logo) => {
			const clone = logo.cloneNode(true);
			clone.setAttribute('aria-hidden', 'true');
			clone.querySelectorAll('img').forEach((img) => {
				img.setAttribute('alt', '');
			});
			track.appendChild(clone);
		});

		track.dataset.marqueeReady = 'true';
		row.classList.add('is-marquee');
	});
})();
